import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'ui-kanban-column',
  styleUrl: './kanban-column.scss',
  templateUrl: './kanban-column.html',
})
export class KanbanColumnComponent {
  /** Titre de la colonne. */
  readonly title = input.required<string>();

  /** Nombre de cartes dans la colonne. */
  readonly itemCount = input(0);

  /** Message affiché quand la colonne est vide. */
  readonly emptyMessage = input('Aucune tâche');
}
